import { getEnvironmentDetails } from '@/utils/env';

export const devLog = (...args: Parameters<typeof console.log>) => {
  return (
    getEnvironmentDetails().isDevelopmentEnvironment && console.log(...args)
  );
};

export const ssrDevLog = (...args: Parameters<typeof console.log>) => {
  return typeof window === 'undefined' && devLog(...args);
};
